module.exports = __webpack_public_path__ + "static/img/third2_2_active.cc73b09b.png";